import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Observable, combineLatest, map } from 'rxjs';

import { ElementTypes, Step } from '@fcom/common';
import { MediaQueryService } from '@fcom/common/services';
import { BookingSteps } from '@fcom/common/interfaces/booking-step.interface';
import { BookingService } from '@fcom/booking/services';
import { ConfigService } from '@fcom/core/services';
import { BOOKING_STEPS } from '@fcom/common/config/booking-config';

@Component({
  selector: 'fin-sub-header',
  styleUrls: ['sub-header.component.scss'],
  templateUrl: 'sub-header.component.html',
})
export class SubHeaderComponent implements OnInit {
  STEPS: BookingSteps = BOOKING_STEPS;
  readonly ElementTypes = ElementTypes;

  @Input()
  hasBasket: boolean;
  @Input()
  isBasketDisabled: boolean;
  @Input()
  hasActiveBasketState: boolean;
  @Input()
  hasBasketActionInMobileOnly: boolean;
  @Input()
  backgroundColorClass = 'nordic-blue-900-bg';
  @Input()
  showInfoIcon: boolean;

  @Output()
  openBasket: EventEmitter<Event> = new EventEmitter<Event>();
  @Output()
  changeStep: EventEmitter<Step> = new EventEmitter<Step>();

  isMobile$: Observable<boolean>;
  step$: Observable<Step>;
  showModifyButton$: Observable<boolean>;

  constructor(
    private mediaQueryService: MediaQueryService,
    private bookingService: BookingService,
    private configService: ConfigService
  ) {
    this.isMobile$ = this.mediaQueryService.isBreakpoint$('mobile');
    this.step$ = this.bookingService.step;
  }

  ngOnInit(): void {
    const isDisabledGreyBanner = this.configService.cfg.disableGreyBanner && this.showInfoIcon;

    this.showModifyButton$ = combineLatest([this.isMobile$, this.step$]).pipe(
      map(
        ([isMobile, step]) => !isMobile && isDisabledGreyBanner && step.phase === BOOKING_STEPS.FLIGHT_SELECTION.phase
      )
    );
  }
}
